<template>
  <div class="content">
    <el-dialog v-bind="$attrs" v-on="$listeners" @open="onOpen" title="新增">
      <el-row :gutter="15">
        <el-form
          ref="addRef"
          :model="advertising"
          :rules="rules"
          size="medium"
          label-width="100px"
        >
          <el-form-item label="分类名称" prop="categoryName">
            <el-input
              v-model="advertising.categoryName"
              clearable
              :style="{ width: '100%' }"
              placeholder="请输入分类名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="上传照片" prop="categoryImg">
              <!-- <el-input style="width: 220px" v-model="ruleForm.img" size="small" :disabled="typedia == 2"></el-input> -->
              <el-upload
                :disabled="
                  $route.query.typeVal == 2 || $route.query.typeVal == 3
                "
                :action="interfaceUrl"
                :http-request="upLoad"
                :show-file-list="false"
                class="avatar-uploader"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload"
                name="file"
                :file-list="fileList"
                :on-change="changeUpload"
              >
                <img
                  width="150px"
                  geight="150px"
                  v-if="advertising.categoryImg != ''"
                  :src="`${VUE_APP_DOWNLOAD}${advertising.categoryImg}`"
                  :v-model="advertising.categoryImg"
                  class="avatar"
                />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
              <div style="color: red">
                备注：请选择(.jpg、.png)格式图片上传，图片尺寸（202*202）!
              </div>
            </el-form-item>
        </el-form>
      </el-row>
      <div slot="footer" v-if="true">
        <el-button @click="close">取消</el-button>
        <el-button type="primary" @click="handelConfirm">确定</el-button>
      </div>
    </el-dialog>
    <!--图片裁剪 ============================================== -->
    <picCutPage ref="picCutPage" @valWidthAndHeight="valWidthAndHeight" />
  </div>
</template>
<script>
import {upload,addFoodMenu}  from '@/api/shopMenu';
import picCutPage from "./picCut.vue";
export default {
  components: {
    picCutPage,
  },
  inheritAttrs: false,
  props: [""],
  data() {
    return {
      imgBtnVals: 0,
      interfaceUrl: "", // 上传后台的接口地址
      fileList: [],
      validWidth: 202,
      validHeight: 202,
      //VUE_APP_DOWNLOAD: "http://localhost:50009/download/",
      VUE_APP_DOWNLOAD: process.env.VUE_APP_DOWNLOAD,
      advertising: {
        id:"", 
        categoryName: "",  //分类名称
        categoryImg: "",  //分类图片
        img:[]
      },
      rules: {
        categoryNme: [
          {
            required: true,
            message: "分类名称不能为空",
            trigger: "blur",
          },
        ],
        categoryImg: [
          {
            required: true,
            message: "分类图片不能为空",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {},
  watch: {},
  created() {
    // this.getAppSystemNameOptions();
  },
  mounted() {},
  methods: {
   // 验证图片宽高
   valWidthAndHeight(formData) {
      // const formData = new FormData(); // 通过form数据格式来传
      //  formData.append("file", file.file); // 传文件
      upload(formData).then((res) => {
        console.log(res);
        this.advertising.categoryImg = res.data.fileName;
        this.$refs.picCutPage.dialogVisible = false;
        this.$message.success("文件上传成功");
      });
    },
    // 点击更换头像
    handleAvatarSuccess(res, file) {
      // 这句话就是连接后台服务器的
      // this.ruleForm.picName = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      const isJPG =
        file.type == "image/jpeg" ||
        file.type == "image/png" ||
        file.type == "image/gif";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG/PNG/GIF 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return (isJPG || isPNG) && isLt2M;
    },
    changeUpload(file, fileList) {
      this.$refs.picCutPage.handleChangeUpload(file, fileList);
      this.$refs.picCutPage.option.autoCropWidth = 202;
      this.$refs.picCutPage.option.autoCropHeight = 202;
    },
    upLoad(file) {
      // if (this.validWidth && this.validHeight) {
      //   return this.valWidthAndHeight(file);
      // }
    },
    handleChange(value){
      console.log("handleChange-value",value);
    },
    onOpen() {},
    onClose() {
      this.$refs["addRef"].resetFields();
    },
    close() {
      this.$emit("update:visible", false);
    },
    handelConfirm() {
      console.log("advertising",this.advertising);
      this.$refs["addRef"].validate((valid) => {
        if (valid) {
          console.log("valid",valid);
          addFoodMenu(this.advertising).then((res) => {
            if (res.code == 10000) {
              this.$emit("add-success");
            }
          });
          this.close();
        }
      });
    },
    getAppSystemNameOptions() {
      // 注意：this.$axios是通过Vue.prototype.$axios = axios挂载产生的
      this.$axios({
        method: "get",
        url: "/api/yys/appSystem/getAll",
      }).then((resp) => {
        let { data } = resp;
        let list = data.data;
        const newOptions = list.map((item) => {
          return {
            value: item["id"],
            label: item["appSystemName"],
          };
        });
        this.appSystemNameOptions = newOptions;
        // this.appSystemNameOptions = data.undefined
      });
    },
  },
};
</script>
<style>
.content {
  background-color: #fff;
  padding: 10px;
  
}
</style>
